// Shared constants for agenda module
export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const TIME_SLOTS = [
  '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', 
  '10:00', '10:30', '11:00', '11:30', '12:00', '12:30',
  '13:00', '13:30', '14:00', '14:30', '15:00'
];

export const INSTITUCIONES = [
  'IGSS',
  'Particular',
  'Seguro Médico',
  'Convenio Empresarial',
  'Otro'
];

export const STATUS_CONFIG = {
  PROGRAMADA: { label: 'Programada', color: 'bg-blue-100 text-blue-700', bgCard: 'bg-blue-50 border-l-blue-500' },
  COMPLETADA: { label: 'Asistió', color: 'bg-emerald-100 text-emerald-700', bgCard: 'bg-emerald-50 border-l-emerald-500' },
  CANCELADA: { label: 'Cancelada', color: 'bg-red-100 text-red-700', bgCard: 'bg-red-50 border-l-red-500 opacity-60' },
  NO_ASISTIO: { label: 'No Asistió', color: 'bg-amber-100 text-amber-700', bgCard: 'bg-amber-50 border-l-amber-500' },
  REPROGRAMADA: { label: 'Reprogramada', color: 'bg-purple-100 text-purple-700', bgCard: 'bg-purple-50 border-l-purple-500' },
};

export const initialFormData = {
  patient_name: '',
  fecha_nacimiento: '',
  edad: 0,
  telefono: '',
  correo: '',
  nit: '',
  institucion: '',
  medico_referente: '',
  tipo_examen: '',
  examenes: [{ tipo_examen: '', duracion: 30 }],
  duracion: 30,
  date: '',
  hora_inicio: '',
  hora_fin: '',
  notes: '',
  status: 'PROGRAMADA',
  sync_google_calendar: false,
  // IGSS fields
  igss_afiliacion: '',
  igss_codigo: '',
  igss_nog: '',
  igss_spg: '',
  igss_unidad_referente: '',
};
